import ChipImc from './ChipImc';

export default ChipImc;
